import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.at.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.find-last.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.find-last-index.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.to-reversed.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.to-sorted.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.typed-array.with.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.array-buffer.detached.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.array-buffer.transfer.mjs';
import '../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/es.array-buffer.transfer-to-fixed-length.mjs';

function getSecureMathRandomServer() {
  const array = new Uint32Array(1);
  const maxNumber = Math.pow(2, 32) - 1;
  if (!crypto || !crypto?.getRandomValues) {
    // eslint-disable-next-line no-console
    console.log("If the node version is less than 20, a require ('crypto') is required. To use the getSecureMathRandomServer properly, update the node version to 20 or higher.");
    return Math.random();
  }
  return crypto.getRandomValues(array)[0] / maxNumber;
}

export { getSecureMathRandomServer };
